import { Component, input, output } from '@angular/core';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
} from '@ionic/angular/standalone';

@Component({
  selector: 'app-home-card',
  imports: [IonCard, IonCardContent, IonCardHeader, IonButton, IonCardTitle],
  templateUrl: './home-card.component.html',
  styleUrl: './home-card.component.scss',
})
export class HomeCardComponent {
  buttonText = input.required<string>();
  imageSrc = input.required<string>();
  bodyText = input.required<string>();
  headerText = input.required<string>();
  buttonClick = output<void>();
}
